import React from "react";
import "../assets/styles/notFound.scss";
import "../assets/styles/animation.scss";

const NotFound = () => {
  return (
    <div className="notfound">
      <div className="notfound__container">
        <div className="notfound__illustration" aria-hidden="true">
          <span className="notfound__ball notfound__ball--1" />
          <span className="notfound__ball notfound__ball--2" />
          <span className="notfound__ball notfound__ball--3" />
          <span className="notfound__ball notfound__ball--4" />
        </div>

        <h1 className="notfound__title">404</h1>
        <p className="notfound__subtitle">Strona nie znaleziona</p>
        <p className="notfound__message">
          Ta strona oczekuje na implementację
        </p>
      </div>
    </div>
  );
};

export default NotFound;